import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "chunk-reload-attempted";

/**
 * Lazy import that recovers from stale chunk hashes after a new deploy.
 * On a failed dynamic import, reloads the page once to fetch the new manifest.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      const mod = await factory();
      window.sessionStorage.removeItem(RELOAD_KEY);
      return mod;
    } catch (error) {
      const alreadyTried = window.sessionStorage.getItem(RELOAD_KEY);
      if (!alreadyTried) {
        window.sessionStorage.setItem(RELOAD_KEY, "true");
        window.location.reload();
        // Never resolves; page is reloading.
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
